import { useFormContext } from 'react-hook-form';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { withDialogSuspenseErrorBoundary } from '@retail/components';
import { CreateSalesPriceConditionSchema } from '@retail/calculus/components';
import { CreateSalesPriceConditionDialogContent } from './CreateSalesPriceConditionDialogContent';
import { PriceSuggestionTypeWithCount } from '@retail/price-suggestion/types';
import { CreateConditionDialog } from '../../ConditionActionsBase';
import { useMemo } from 'react';
import { ConditionsNew } from '@retail/calculus/types';

interface Props {
  open: boolean;
  salesPriceConditions: ConditionsNew[];
  supplierNumber?: number;
  filteredPriceSuggestions: PriceSuggestionTypeWithCount[];
  includeMarkup: boolean;
  includeUnit: boolean;
  isLoadingFetchPriceSuggestions: boolean;
  submitConditions: (data: CreateSalesPriceConditionSchema) => void;
  onClose: () => void;
}

function FollowPriceSuggestionDialog({
  open,
  salesPriceConditions,
  filteredPriceSuggestions,
  supplierNumber,
  includeMarkup,
  includeUnit,
  isLoadingFetchPriceSuggestions,
  submitConditions,
  onClose,
}: Props) {
  const t = useCalculusTFunction();

  const { watch, handleSubmit } = useFormContext<CreateSalesPriceConditionSchema>();

  const excistingConditionLevelIds = useMemo(
    () => salesPriceConditions.filter((cond) =>
      watch('level') === 'discountGroup' ? cond.bindingType === 'DISCOUNT_GROUP' : ['OVERGRUPPE', 'HOVEDGRUPPE', 'VAREGRUPPE'].includes(cond.bindingType)).map((cond) => cond.bindingTargetId),
    [salesPriceConditions, watch]);

  return (
    <CreateConditionDialog
      open={open}
      title={t('calculus.salesPriceCondition.newSalesPriceCondition')}
      supplierNumber={supplierNumber}
      includePackages={includeUnit}
      excistingConditionLevelIds={excistingConditionLevelIds}
      dialogContent={
        <CreateSalesPriceConditionDialogContent
          priceSuggestionTypes={filteredPriceSuggestions}
          includeMarkup={includeMarkup}
          supplierNumber={supplierNumber}
          isLoadingFetchPriceSuggestions={isLoadingFetchPriceSuggestions}
        />
      }
      isDisabled={watch('priceSourcePriority').length === 0}
      onSubmit={handleSubmit(submitConditions)}
      onClose={onClose}
    />
  );
}

export default withDialogSuspenseErrorBoundary(FollowPriceSuggestionDialog);
